module.exports = __webpack_public_path__ + "196ff71cf47f7396085f372d199c03f2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/12_B2.mp3
// module id = 92
// module chunks = 0